import React from 'react';
import './index.css';

class SchoolChats extends React.Component {
    constructor (props) {
        super();
        this.state = {
        };
    }

    componentDidMount() {
        document.body.classList.add('no_search');
    };
    componentWillUnmount() {
        document.body.classList.remove('no_search');
    };

    render() {

        return (
            <div className="school_chats">

                <h1>Чаты со студентами</h1>
                <p>Раздел в разработке.</p>

            </div>
        );
    }
}

export default SchoolChats;